var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "like",
    d: "M16.5188 1.38676C15.5575 0.495322 14.2948 0 12.9837 0C11.6726 0 10.4099 0.495322 9.44854 1.38676L8.99725 1.8169L8.62587 1.46433C7.7591 0.629425 6.63028 0.11995 5.43078 0.0222758C4.23127 -0.0753982 3.03489 0.244739 2.04447 0.928415C1.46588 1.32912 0.983399 1.8532 0.631813 2.46289C0.280226 3.07258 0.0682926 3.75268 0.0112897 4.45416C-0.0368883 5.14565 0.0695331 5.83919 0.322826 6.48442C0.576119 7.12964 0.969926 7.71036 1.47565 8.18441L8.10641 14.4673C8.34659 14.6951 8.66503 14.8221 8.99607 14.8221C9.32712 14.8221 9.64555 14.6951 9.88574 14.4673L16.5188 8.18441C16.9861 7.75035 17.3588 7.22459 17.6136 6.63999C17.8685 6.05538 18 5.4245 18 4.78676C18 4.14902 17.8685 3.51814 17.6136 2.93353C17.3588 2.34893 16.9861 1.82317 16.5188 1.38911V1.38676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.44857116.svg";
export { ForwardRef as ReactComponent };